<template>
  <a @click="goToEvent(item.id)" class="card d-flex flex-row event-card rounded">
    <div class="flex-grow-0 flex-shrink-0 d-flex flex-column justify-content-center top-text px-3 pb-3 event-squared-div event-date rounded-left">
      <span class="text-center font-weight-light event-date-day">{{ getDateDay(item.startTime) }}</span>
      <span class="text-center event-date-month">{{ getDateMonth(item.startTime) }}</span>
      <span class="text-center event-date-year">{{ getDateYear(item.startTime) }}</span>
    </div>
    <div class="flex-grow-0 flex-shrink-0 event-squared-div event-image" :style="`background: url('${getItemImage(item.image)}')`"></div>
    <div class="d-flex flex-column px-3 py-2 event-content">
      <h4 class="mb-0 event-title">{{ item.title }}</h4>
      <div class="d-flex align-items-center mt-2">
        <div class="event-icon-container">
          <div class="icon-shape icon-event">
            <i class="ni ni-pin-3"></i>
          </div>
        </div>
        <div class="event-address">
          <span class="text-sm" v-if="item.address">
            {{ item.address.street }} {{ item.address.number }}, {{ item.address.npa}} {{ item.address.city }}
            <span v-if="item.address.country || item.address.canton">
              (<span v-if="item.address.canton">{{ item.address.canton.code }}</span>
              <span v-if="item.address.country && item.address.country.name !== 'Suisse' && item.address.canton">, </span>
              <span v-if="item.address.country && item.address.country.name !== 'Suisse'">{{ item.address.country.name }}</span>)
            </span>
          </span>
          <span class="text-sm" v-if="!item.address">-</span>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="event-icon-container">
          <div class="icon-shape icon-event">
            <i class="ni ni-calendar-grid-58"></i>
          </div>
        </div>
        <div>
          <span class="text-sm">{{ getEventStatus(item.startTime, item.endTime) }}</span>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      months: ['Janv', 'Févr', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
    };
  },
  props: {
    item: Object,
  },
  methods: {
    goToEvent(index) {
      this.$router.push({ name: 'EventDetails', params: { id: index } });
    },
    getItemImage(imageName) {
      return `${process.env.VUE_APP_API_URL}/files/img/${imageName}`;
    },
    altImage(event) {
      event.target.src = "/img/ciip/ciip-logo.png";
    },
    defaultImage(e) {
      e.target.src = '/img/ciip/ciip-logo.png';
    },
    getEventStatus(start, end) {
      const from = moment(start, 'YYYY-MM-DDThh:mm:ssZ');
      const to = moment(end, 'YYYY-MM-DDThh:mm:ssZ');
      const now = moment();

      if (now.isAfter(from) && now.isBefore(to)) {
        return 'Aujourd\'hui';
      } else if (from.diff(now.add(1, 'days'), 'days') === 0) {
        return 'Demain';
      } else if (now.isAfter(to)) {
        return 'Terminé';
      } else if (now.isBefore(from)) {
        return `Débute dans ${from.diff(now, 'days')} jours`;
      }

      return null;
    },
    getDateDay(date) {
      const eventDate = new Date(date);
      return eventDate.getDate();
    },
    getDateMonth(date) {
      const eventDate = new Date(date);
      return this.months[eventDate.getMonth()];
    },
    getDateYear(date) {
      const eventDate = new Date(date);
      return eventDate.getFullYear();
    },
    convertMS(milliseconds) {
      const seconds = Math.floor(milliseconds / 1000);
      const minute = Math.floor(seconds / 60);
      const hour = Math.floor(minute / 60);
      const day = Math.floor(hour / 24);
      return day;
    },
  },
};
</script>

<style lang="css" scoped>
  .top-icon {
    width: auto;
    height: auto;
    background-color: transparent;
  }

  .top-text {
    line-height: 1;
  }

  .card {
    box-shadow: 2px 4px 25px rgba(0, 0, 0, .1) !important;
    width: 100%;
  }

  .card:hover {
    box-shadow: 2px 8px 45px rgba(0, 0, 0, .15) !important;
  }
</style>